import React, { useEffect } from 'react'
import { useAuth } from './hooks/useAuth'
import { LoadingSpinner } from '../../shared/components'
import LoginPage from './LoginPage'

interface ProtectedRouteProps {
  children: React.ReactNode
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, user } = useAuth()

  // Handle magic link verification on mount
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const token = urlParams.get('token')
    
    if (token) {
      // Remove token from URL to clean up the address bar
      const newUrl = window.location.pathname
      window.history.replaceState({}, document.title, newUrl)
      
      // The AuthContext will handle session checking automatically
      // which will verify the token and set the user state
    }
  }, [])

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '1rem',
        backgroundColor: '#f5f5f5'
      }}>
        <LoadingSpinner />
        <p style={{
          color: '#666',
          fontSize: '0.9rem',
          margin: 0
        }}>
          Checking authentication...
        </p>
      </div>
    )
  }

  // Show login page if not authenticated
  if (!isAuthenticated || !user) {
    return <LoginPage />
  }

  // Render protected content
  return <>{children}</>
}